import InventorySection from "../components/InventorySection";

export function InventoryDashboard() {
  return (
    <div className="relative w-full h-full overflow-y-auto bg-white text-black dark:text-black">
      <section className="w-full">
        <InventorySection />
      </section>
    </div>
  )
}